// Third-party imports
import React from "react";

// Our imports
import styled from "styled-components";
import Checkbox, { CheckboxOverrides } from "../components/base_ui/inputs/checkbox";
import { NewTab } from "@carbon/icons-react";
import { StyledLink } from "baseui/link";
import { Tooltip } from "../components/base_ui/surfaces/tooltip";
import { InformationFilled } from "@carbon/icons-react";

const EuCitizenContainer = styled.div`
  display: inline-grid;
  grid-template-columns: auto auto;
  grid-gap: 8px;
  align-items: center;
  padding-top: ${({ theme }) => theme.sizing.scale300};
`;

const StyledLinkContainer = styled.div`
  display: inline-grid;
  grid-template-columns: auto auto;
  align-items: center;
  color: ${({ theme }) => theme.colors.primary500};
`;

const EuCitizenCheckboxOverrides: CheckboxOverrides = {
  Label: {
    style: ({ $theme }) => ({
      fontFamily: $theme.typography.LabelMedium.fontFamily,
      fontWeight: $theme.typography.LabelMedium.fontWeight,
      fontSize: $theme.typography.LabelMedium.fontSize,
      lineHeight: $theme.typography.LabelMedium.lineHeight,
      textTransform: "none",
    }),
  },
};

export default function EuCitizenCheckbox({
  euCitizen,
  schoolId,
  onChange,
}: {
  euCitizen: boolean;
  schoolId: string;
  onChange: () => void;
}) {
  // ugly customization for all IU programs -- GDPR does not apply
  if (schoolId === "73") {
    return null;
  }

  return (
    <EuCitizenContainer>
      <div>
        <Checkbox
          aria-label="is EU citizen"
          name="is_eu_citizen"
          checked={euCitizen}
          onChange={onChange}
          overrides={EuCitizenCheckboxOverrides}
          dataTest={"checkbox-is-eu-citizen"}
        >
          I am a citizen of the{" "}
          <StyledLinkContainer>
            <NewTab size={16} />{" "}
            <StyledLink
              href="https://www.gov.uk/eu-eea"
              target="_blank"
              aria-label="European Economic Area, opens in a new tab"
            >
              European Economic Area
            </StyledLink>
          </StyledLinkContainer>
        </Checkbox>
      </div>
      <div
        aria-label={
          "This is not a requirement for the program and you should only click the box if you are a citizen of the European Economic Area."
        }
      >
        <Tooltip
          content={
            <p>
              This is not a requirement for the program and you should only click the box if you are
              a citizen of the European Economic Area.
            </p>
          }
        >
          <InformationFilled size={16}></InformationFilled>
        </Tooltip>
      </div>
    </EuCitizenContainer>
  );
}
